import * as React from 'react'

import Layout from '../layout/SiteLayout'
import { RouteProps } from '../../types'

const RoutePublic = ({
  component: Component,
  location,
  ...rest
}: RouteProps) => {
  const { path, title, description } = rest

  return (
    <Layout
      path={path}
      title={title}
      description={description}
      darktheme={false}
    >
      <Component {...rest} />
    </Layout>
  )
}

export default RoutePublic
